<template>
    <div class="media-carousel"
         ref="mediaCarousel">
        <VueSlickCarousel v-bind="settings"
                          @swipe="setCarouselSwiping(true)"
                          @mouseup.native="setCarouselSwiping(false)"
                          @touchend.native="setCarouselSwiping(false)"
                          class="carousel mb-5">
            <div class="card"
                 ref="card"
                 v-for="(item, index) in agentMedias"
                 :key="index"
                 v-b-modal.modal>
                <div class=" d-flex justify-content-center align-items-center img"
                     :class="{'hoverIn': item.mouseover,'hoverOut': item.mouseout}"
                     :style="{'background-image': `url(${item.imgUrl})`, 'height': `${ytHeight}px`}"
                     :data-ga-element="item.gaStr"
                     @click="showMedia(item)"
                     @mouseover="setHover('mouseover', item)"
                     @mouseout="setHover('mouseout', item)">
                    <div class="triangle"
                         :data-ga-element="item.gaStr" />
                    <p class="title d-none d-md-block"
                       :data-ga-element="item.gaStr">
                        {{item.title}}</p>
                </div>
            </div>
        </VueSlickCarousel>
        <b-modal id="modal"
                 size="lg"
                 hide-header
                 hide-footer>
            <template #default="{ close }">
                <b-button-close size="lg"
                                @click="close()" />
                <div class="d-flex justify-content-center py-2 w-100">
                    <iframe id="ytplayer"
                            class="w-100"
                            :style="{'height': `${modalMediaHeight}px`}"
                            type="text/html"
                            :src="youtubeLink.mediaUrl"
                            frameborder="0"
                            allowfullscreen
                            :data-ga-element="youtubeLink.gaStr" />
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
export default {
    components: {
        VueSlickCarousel,
    },
    data() {
        return {
            ytHeight: 0,
            modalMediaWidth: 0,
            modalMediaHeight: 0,
            agentMedias: [
                {
                    imgUrl: require('../../assets/images/home/agentMedia/agent1.png'),
                    mediaUrl: 'https://www.youtube.com/embed/fNAr_lMDvHs',
                    title: '業務職人 彭士軒',
                    gaStr: '新保險網站_影片業務職人彭士軒',
                    mouseover: false,
                    mouseout: false,
                },
                {
                    imgUrl: require('../../assets/images/home/agentMedia/agent2.png'),
                    mediaUrl: 'https://www.youtube.com/embed/CK2qr7VybLA',
                    title: '業務職人 李鎬年',
                    gaStr: '新保險網站_業務職人李鎬年',
                    mouseover: false,
                    mouseout: false,
                },
                {
                    imgUrl: require('../../assets/images/home/agentMedia/agent3.png'),
                    mediaUrl: 'https://www.youtube.com/embed/fzFLKH9MQKo',
                    title: '業務職人 蔡淑貞 & 吳國川',
                    gaStr: '新保險網站_業務職人蔡淑貞',
                    mouseover: false,
                    mouseout: false,
                },
            ],
            youtubeLink: {},
            settings: {
                dots: true,
                focusOnSelect: true,
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                touchThreshold: 5,
                centerMode: false,
                speed: 500,
                responsive: [
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: false,
                            dots: false,
                            centerMode: true,
                            centerPadding: '20%',
                            touchThreshold: 5,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            infinite: true,
                            dots: true,
                            centerMode: false,
                            touchThreshold: 5,
                        }
                    },
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            infinite: true,
                            dots: true,
                            centerMode: false,
                            touchThreshold: 5,
                        }
                    },
                ],
            }
        };
    },
    mounted() {
        window.addEventListener('resize', this.resizeHandler);
        this.resizeHandler();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeHandler);
    },
    methods: {
        setCarouselSwiping(state) {
            this.swiping = state;
        },
        setHover(active, item) {
            this.agentMedias.map((item) => {
                item.mouseover = false;
                item.mouseout = false;
            });
            item[active] = true;
        },
        showMedia(media) {
            this.youtubeLink = Object.assign(media);
        },
        resizeHandler() {
            const windowWidth = document.body.offsetWidth;
            const carouselWidth = this.$refs.mediaCarousel.offsetWidth;
            // const cardWidth = this.$refs.card.offsetWidth;
            this.ytHeight = windowWidth >= 576 ? (carouselWidth - 60) / 3 * 0.925 * 0.563 : carouselWidth * 0.6 * 0.925 * 0.563;
            this.modalMediaHeight = windowWidth * 0.8 > 700 ? 393 : windowWidth * 0.8 * 0.565;
        },
    },
};
</script>

<style lang="scss" scoped>
.slick-slider.--swiping {
    .slick-list:after {
        content: '';
        position: absoulte;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
    }
}
.carousel {
    margin: auto;
    width: 100%;
    @include media-breakpoint-up(sm) {
        width: calc(100% - 56px);
    }
}
::v-deep .slick-dots {
    li {
        width: 10px;
        height: 10px;
    }

    li button {
        border: 1px solid #dddddd;
        border-radius: 800px;
        width: 9px;
        height: 9px;
        padding: 0;
        background: #fff;
        &:before {
            content: '';
        }
    }

    li.slick-active button {
        border: 1px solid #dddddd;
        border-radius: 800px;
        width: 9px;
        height: 9px;
        padding: 0;
        background: #0089d1;
        &:before {
            content: '';
        }
    }
}
::v-deep .slick-slider .slick-arrow:before {
    content: '';
    border: 0;
    @include media-breakpoint-up(sm) {
        border: solid #0089d1;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 9px;
    }
}

::v-deep button.slick-next:before {
    margin-left: -16px;
    transform: rotate(-45deg);
}
::v-deep .slick-arrow.slick-prev:before {
    margin-left: 6px;
    transform: rotate(135deg);
}
.card {
    padding-left: 3.75%;
    padding-right: 3.75%;
    border: 0;
    border-radius: 0;
    outline: 0;
    .img {
        cursor: pointer;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
        &.hoverIn {
            animation: scale 0.25s linear forwards;
        }
        &.hoverOut {
            animation: scale2 0.25s reverse linear forwards;
        }
        @keyframes scale {
            from {
                filter: contrast(1);
                background-size: 100%;
            }
            to {
                filter: contrast(1.25);
                background-size: 110%;
            }
        }
        @keyframes scale2 {
            from {
                filter: contrast(1);
                background-size: 100%;
            }
            to {
                filter: contrast(1.25);
                background-size: 110%;
            }
        }
    }
    .title {
        font-size: 0.875rem;
        letter-spacing: 0.5px;
        margin: 0;
        position: absolute;
        color: #fff;
        position: absolute;
        bottom: 8px;
        right: 8px;
        text-shadow: 0px 2px 4px #000000ce;
        @include media-breakpoint-up(lg) {
            font-size: 1rem;
            bottom: 10px;
            right: 10px;
        }
    }
    .triangle {
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 3.6vw 0 3.6vw 6.4vw;
        border-color: transparent transparent transparent #ffffff;
        opacity: 0.65;
        @include media-breakpoint-up(sm) {
            border-width: 2.5vw 0 2.5vw 4.2vw;
        }
        @include media-breakpoint-up(lg) {
            border-width: 25px 0 25px 41px;
        }
    }
}
::v-deep .modal-content {
    background-color: transparent;
    border: 0;
    max-width: 700px !important;
    .modal-body {
        padding: 1rem 0;
    }
    .close {
        font-size: 2.5rem;
        font-weight: 100;
        color: #fff;
        opacity: 1;
        position: absolute;
        right: -26px;
        line-height: 0.65;
    }
}
::v-deep .modal-dialog {
    width: 80% !important;
    max-width: 700px !important;
    margin: auto;
}
</style>
